import { createSelector } from 'reselect';

export const mapTemplatesWithCash = (templates, conversionForCash) => {
   if (conversionForCash && templates) {
        const cashTemplate = [{ code: 'cash', name: 'Cash' }];

        return cashTemplate.concat(templates);
   }

   return templates;
};

export const mapBonusesConversionWithCash = (bonusesConversion, conversionForCash) => {
    if (conversionForCash) {
        const cashTemplate = [{ ...conversionForCash, bonusTemplateCode: 'cash', bonusName: 'Cash' }];

        return cashTemplate.concat(bonusesConversion);
    }

    return bonusesConversion;
};

export const getTemplates = state => state.bonusTemplates;
export const getCashConversion = state => state.conversion && state.conversion.moneyConversionDetails;
export const getBonusesConversion = state => state.conversion && state.conversion.bonusConversionDetails;

export const mapTemplates = createSelector(
    [getTemplates, getCashConversion],
    (templates, conversion) => mapTemplatesWithCash(templates, conversion)
);

export const mapConversion = createSelector(
    [getBonusesConversion, getCashConversion],
    (bonusesConversion, cashConversion) => mapBonusesConversionWithCash(bonusesConversion, cashConversion)
);
